export default __webpack_public_path__ + "static/media/pepsi.b3e91e44.png";